module.exports = __webpack_public_path__ + "img/article-2-4.a04e3fec.jpg";